module.exports = __webpack_public_path__ + "static/activities-d9d0d6c09241eefa9d3d00261cfb0b3b.jpg";